// extracted by mini-css-extract-plugin
export const container = "layout-module--container--2tC13";
export const content = "layout-module--content--OyLTg";